// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#profile-container {
  border: 1px solid #00375d;
}

#student-sidebar {
  font-family: Verdana, Arial, sans-serif;
  font-size: 16px;
  text-align: center;
  color: white;
  margin-top: 15px;
}

#student-sidebar #student-name {
  font-family: Rockwell, Verdana, Arial, sans-serif;
  font-size: 24px;
}

#student-sidebar #profile-header {
  background-color: #00375d;
  padding-top: 15px;
  padding-bottom: 15px;
}

#student-sidebar a:hover,
#student-sidebar a:visited,
#student-sidebar a:link,
#student-sidebar a:active {
  font-family: inherit;
  font-size: 12px;
  color: inherit;
  text-decoration: none;
}

#profile-container #profile-summary {
  color: #505050;
  padding-top: 15px;
  padding-bottom: 15px;
}

#student-sidebar #profile-header .border-right {
  border-right: 1px solid white;
}

#profile-header > div {
  padding-bottom: 5px;
}

#student-sidebar hr {
  border-top: 2px solid white;
  height: 10px;
  margin: 5px 15px 0px 15px;
}

#student-sidebar .profile-action {
  padding-right: 8px;
}

#profile-header #messages-row {
  padding-bottom: 0px;
  font-size: 12px;
}

#student-sidebar .secondary-blue {
  color: #1eabe3;
}

#student-sidebar .category {
  font-size: 14px;
  font-weight: 900;
  padding-top: 7px;
}

#student-sidebar .count {
  font-size: 24px;
  font-weight: 900;
}

#profile-summary > div,
#cp-summary > div {
  padding-bottom: 5px;
}

#student-sidebar #cp-summary-container {
  border: 1px solid #0579ab;
  border-top: none;
  color: #505050;
  padding-top: 15px;
  padding-bottom: 15px;
}

#student-sidebar .section-title {
  font-size: 18px;
  font-family: Rockwell, Verdana, Arial, sans-serif;
  color: #00375d;
  font-weight: bold;
}

#cp-summary-container .cp-badge {
  text-align: left;
  float: left;
  padding-right: 15px;
}

#cp-ellipses {
  font-size: 24px;
  font-family: Rockwell;
  font-weight: bold;
  float: left;
  width: 48px;
}

#student-sidebar #transcript-summary-container {
  border: 1px solid #0579ab;
  border-top: none;
  color: #505050;
  padding-top: 15px;
  padding-bottom: 15px;
}

.transcriptTitle {
  font-size: 14px;
  font-weight: 900;
  padding-top: 7px;
  max-width: 70%;
  overflow-wrap: break-word;
  word-break: break-word;
  word-wrap: break-word;
  overflow: hidden;
  text-align: left;
}

.transcriptDate {
  padding-top: 7px;
  max-width: 30%;
  overflow-wrap: normal;
}

.transcriptLink {
  padding-top: 7px;
  overflow-wrap: normal;
  text-align: right;
}

#student-sidebar #help-container {
  border: 1px solid #0579ab;
  border-top: none;
  color: #505050;
  padding-top: 15px;
  padding-bottom: 15px;
}

.helpImage {
  margin-bottom: 5px;
  margin-right: 10px;
}

#help-summary .category {
  margin-top: 11px;
}

#help-summary .helpImage:first-of-type {
  margin-top: 5px;
}

#student-sidebar #ldc-container {
  border: 1px solid #0579ab;
  border-top: none;
  color: #505050;
  padding-top: 15px;
  padding-bottom: 15px;
}

#ldc-summary .category {
  margin-top: 11px;
}

#ldc-summary .helpImage:first-of-type {
  margin-top: 5px;
}
`, "",{"version":3,"sources":["webpack://./apps/lms/src/css/studentui/studentSidebar.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;AAC3B;;AAEA;EACE,uCAAuC;EACvC,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,iDAAiD;EACjD,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;;;;EAIE,oBAAoB;EACpB,eAAe;EACf,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,iDAAiD;EACjD,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,iBAAiB;EACjB,WAAW;EACX,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;EACtB,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB","sourcesContent":["#profile-container {\n  border: 1px solid #00375d;\n}\n\n#student-sidebar {\n  font-family: Verdana, Arial, sans-serif;\n  font-size: 16px;\n  text-align: center;\n  color: white;\n  margin-top: 15px;\n}\n\n#student-sidebar #student-name {\n  font-family: Rockwell, Verdana, Arial, sans-serif;\n  font-size: 24px;\n}\n\n#student-sidebar #profile-header {\n  background-color: #00375d;\n  padding-top: 15px;\n  padding-bottom: 15px;\n}\n\n#student-sidebar a:hover,\n#student-sidebar a:visited,\n#student-sidebar a:link,\n#student-sidebar a:active {\n  font-family: inherit;\n  font-size: 12px;\n  color: inherit;\n  text-decoration: none;\n}\n\n#profile-container #profile-summary {\n  color: #505050;\n  padding-top: 15px;\n  padding-bottom: 15px;\n}\n\n#student-sidebar #profile-header .border-right {\n  border-right: 1px solid white;\n}\n\n#profile-header > div {\n  padding-bottom: 5px;\n}\n\n#student-sidebar hr {\n  border-top: 2px solid white;\n  height: 10px;\n  margin: 5px 15px 0px 15px;\n}\n\n#student-sidebar .profile-action {\n  padding-right: 8px;\n}\n\n#profile-header #messages-row {\n  padding-bottom: 0px;\n  font-size: 12px;\n}\n\n#student-sidebar .secondary-blue {\n  color: #1eabe3;\n}\n\n#student-sidebar .category {\n  font-size: 14px;\n  font-weight: 900;\n  padding-top: 7px;\n}\n\n#student-sidebar .count {\n  font-size: 24px;\n  font-weight: 900;\n}\n\n#profile-summary > div,\n#cp-summary > div {\n  padding-bottom: 5px;\n}\n\n#student-sidebar #cp-summary-container {\n  border: 1px solid #0579ab;\n  border-top: none;\n  color: #505050;\n  padding-top: 15px;\n  padding-bottom: 15px;\n}\n\n#student-sidebar .section-title {\n  font-size: 18px;\n  font-family: Rockwell, Verdana, Arial, sans-serif;\n  color: #00375d;\n  font-weight: bold;\n}\n\n#cp-summary-container .cp-badge {\n  text-align: left;\n  float: left;\n  padding-right: 15px;\n}\n\n#cp-ellipses {\n  font-size: 24px;\n  font-family: Rockwell;\n  font-weight: bold;\n  float: left;\n  width: 48px;\n}\n\n#student-sidebar #transcript-summary-container {\n  border: 1px solid #0579ab;\n  border-top: none;\n  color: #505050;\n  padding-top: 15px;\n  padding-bottom: 15px;\n}\n\n.transcriptTitle {\n  font-size: 14px;\n  font-weight: 900;\n  padding-top: 7px;\n  max-width: 70%;\n  overflow-wrap: break-word;\n  word-break: break-word;\n  word-wrap: break-word;\n  overflow: hidden;\n  text-align: left;\n}\n\n.transcriptDate {\n  padding-top: 7px;\n  max-width: 30%;\n  overflow-wrap: normal;\n}\n\n.transcriptLink {\n  padding-top: 7px;\n  overflow-wrap: normal;\n  text-align: right;\n}\n\n#student-sidebar #help-container {\n  border: 1px solid #0579ab;\n  border-top: none;\n  color: #505050;\n  padding-top: 15px;\n  padding-bottom: 15px;\n}\n\n.helpImage {\n  margin-bottom: 5px;\n  margin-right: 10px;\n}\n\n#help-summary .category {\n  margin-top: 11px;\n}\n\n#help-summary .helpImage:first-of-type {\n  margin-top: 5px;\n}\n\n#student-sidebar #ldc-container {\n  border: 1px solid #0579ab;\n  border-top: none;\n  color: #505050;\n  padding-top: 15px;\n  padding-bottom: 15px;\n}\n\n#ldc-summary .category {\n  margin-top: 11px;\n}\n\n#ldc-summary .helpImage:first-of-type {\n  margin-top: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
